<div class="app-version-block-content">
  <div class="icon-circle">
    <ion-icon name="download-outline"></ion-icon>
  </div>
  <div class="copy">
    <h2 class="title">Nueva versión disponible</h2>
    <p class="message">
      Para continuar usando la aplicación, es necesario actualizarla a la última versión disponible.
    </p>
  </div>
  <ion-button expand="block" mode="md" (click)="onUpdate()">
    Actualizar
  </ion-button>
  <p class="footer">
    Versión instalada {{ currentVersion }} · Mínima requerida {{ minSupportedVersion }}
  </p>
</div>
